import { get, post } from "@/request/http";

// 获取基地列表
export const getBaseList = p => get("/base/getBaseList", p);

// 删除基地
export const deleteBase = p => post("/base/deleteBase", p);

// 添加，修改基地
export const changeBase = p => post("/base/changeBase", p);


